import React, { useState, useEffect } from 'react';
import AgentAutomationManagePanel from '../Panels/AgentAutomationManagePanel';
import AgentAutomationSchedulePanel from '../Panels/AgentAutomationSchedulePanel';
import TemplateManagerPanel from '../Panels/TemplateManagerPanel';

import { WebAPI } from '../../MedicareProAPI/API/WebAPI';

export default function AgentAutomationsPage(props) {
  const [currentTab, setCurrentTab] = useState('manage');
  const [hasAccess, setHasAccess] = useState();

  const webAPI = new WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  webAPI
    .getUsersAutomationAccess(props.userId)
    .then((response) => setHasAccess(true))
    .catch((e) => setHasAccess(false));

  const sections = [
    {
      id: 'manage',
      label: 'Manage',
      successClass: 'btn-primary',
      icon: 'fa-clock',
    },
    {
      id: 'schedule',
      label: 'Schedule',
      successClass: 'btn-success',
      icon: 'fa-clock',
    },
  ];
  return (
    <>
      <div className="row mb-3">
        {hasAccess === undefined && (
          <div className="col-12 mb-2">
            <p className="alert alert-info">
              <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
            </p>
          </div>
        )}
        {hasAccess === false && (
          <>
            <div className="card mt-4 h-auto">
              <div className="card-body mt-2">
                <div className="row">
                  <div className="col-12 mb-2">
                    <p className="alert alert-warning mb-5">
                      <i className="far fa-exclamation-circle mr-2"></i>The Automation Platform is
                      an optional add-on. Please head over to your{' '}
                      <a href="/agent/settingsController/index/billing">
                        account subscriptions page
                      </a>{' '}
                      to enable this.
                    </p>
                    <h4 className="text-center calMess">
                      <b>What is the Automations Platform?</b>
                    </h4>
                  </div>

                  <div className="col-12 col-lg-6">
                    <div className="rounded p-2 bg-light mt-5 pt-3 pl-3">
                      <h6 className="text-info">
                        <b>
                          <i className="far fa-chart-network mr-2"></i>Dynamic Lead Drip Campaigns:
                        </b>
                      </h6>
                      <ul>
                        <li>Set up automated email sequences to nurture leads over time.</li>
                        <li>
                          Customize email content and frequency to align with your sales strategy.
                        </li>
                        <li>
                          Keep your brand top-of-mind with consistent and engaging communication.
                        </li>
                      </ul>
                    </div>

                    <div className="rounded p-2  mt-3 pt-3 pl-3">
                      <h6 className="text-success">
                        <b>
                          <i className="far fa-chart-network mr-2"></i>Triggered Actions for Policy
                          Updates or new clients:
                        </b>
                      </h6>
                      <ul className="calMess">
                        <li>
                          Send instant client notifications when policies are added or updated on an
                          account.
                        </li>
                        <li>
                          Set up a complete New Client automation that sends them 30, 60, 90 day
                          follow ups automatically. Or whatever you want.
                        </li>
                        <li>
                          Instantly create activities for yourself or staff members when policies
                          become effective.
                        </li>
                        <li>Automatically sent out client communications on birthdays.</li>
                      </ul>
                    </div>

                    <div className="rounded p-2 bg-light mt-3 pt-3 pl-3">
                      <h6 className="text-info">
                        <b>
                          <i className="far fa-chart-network mr-2"></i>Personalized Activity
                          Management:
                        </b>
                      </h6>
                      <ul>
                        <li>
                          Set activities for yourself based on specific triggers within the CRM.
                        </li>
                        <li>
                          Stay organized and focused on high-priority actions to drive sales
                          success.
                        </li>
                      </ul>
                    </div>

                    <div className="rounded p-2  mt-3 pt-3 pl-3">
                      <h6 className="text-success">
                        <b>
                          <i className="far fa-chart-network mr-2"></i>Seamless External Vendor
                          Integration:
                        </b>
                      </h6>
                      <ul className="calMess">
                        <li>
                          Automatically sync contacts and data with external vendors and partners.
                        </li>
                        <li>
                          Eliminate manual data entry and ensure consistency across platforms.
                        </li>
                        <li>
                          Enhance collaboration and streamline workflows for greater efficiency.
                        </li>
                      </ul>
                    </div>

                    <div className="rounded p-2 bg-light mt-3 pt-3 pl-3">
                      <h6 className="text-info">
                        <b>
                          <i className="far fa-chart-network mr-2"></i>Flexible Automation Options:
                        </b>
                      </h6>
                      <ul>
                        <li>Customize automation workflows to suit your unique sales processes.</li>
                        <li>Create custom triggers and actions tailored to your specific needs.</li>
                        <li>
                          Scale your automation efforts as your business grows, adapting to evolving
                          requirements effortlessly.
                        </li>
                      </ul>
                    </div>

                    <div className="rounded p-2  mt-3 pt-3 pl-3">
                      <h6 className="text-success">
                        <b>
                          <i className="far fa-chart-network mr-2"></i>Intuitive User Interface:
                        </b>
                      </h6>
                      <ul className="calMess">
                        <li>
                          User-friendly automation builder and interface make it easy to set up and
                          manage automation workflows.
                        </li>
                        <li>
                          No coding skills required—fill out the automation form to create custom
                          workflows.
                        </li>
                        <li>
                          Empower your agents to focus on what they do best—closing deals—while our
                          platform handles the rest.
                        </li>
                        <li>Automaton log monitoring and schedule overviews.</li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-lg-block text-center pt-5">
                    <h6>
                      <b>Lead Drip Automation</b>
                    </h6>
                    <h6 className="mb-0 mt-3">
                      <span className="badge badge-pill badge-primary p-2 px-3">
                        Lead - Status Change
                      </span>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-success p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>Immediately
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-at"></i>Send - Email
                      </span>

                      <i className="fal fa-long-arrow-right ml-2 mr-2 calMess"></i>
                      <img
                        className=" pt-0 mt-0 automation-action-vendor-badge"
                        alt="{}"
                        src="https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/microsofticon.png"
                      ></img>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-indigo p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>1 Week Later
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-comment"></i>Send - SMS
                      </span>

                      <i className="fal fa-long-arrow-right ml-2 mr-2 calMess"></i>
                      <img
                        className=" pt-0 mt-0 automation-action-vendor-badge"
                        alt="{}"
                        src="https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/ringcentralicon.png"
                      ></img>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-salmon p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>1 Month Later
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-mailbox"></i>Send - Mail
                      </span>

                      <i className="fal fa-long-arrow-right ml-2 mr-2 calMess"></i>
                      <img
                        className=" pt-0 mt-0 automation-action-vendor-badge"
                        alt="{}"
                        src="https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/thanksioicon.png"
                      ></img>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-salmon p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>3 Month Later
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-user-alt"></i>Change - Lead Status
                      </span>
                    </h6>

                    <div className="mt-5 mb-5">
                      <hr></hr>
                    </div>

                    <h6>
                      <b>Active Policy Automation</b>
                    </h6>
                    <h6 className="mb-0 mt-3">
                      <span className="badge badge-pill badge-primary p-2 px-3">
                        Policy - Status Change
                      </span>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-success p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>Immediately
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-at"></i>Send - Email
                      </span>

                      <i className="fal fa-long-arrow-right ml-2 mr-2 calMess"></i>
                      <img
                        className=" pt-0 mt-0 automation-action-vendor-badge"
                        alt="{}"
                        src="https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/microsofticon.png"
                      ></img>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-success p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>Immediately
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-list"></i>Create - Activity
                      </span>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-cyan p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>5 Days Later
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-comment"></i>Send - SMS
                      </span>

                      <i className="fal fa-long-arrow-right ml-2 mr-2 calMess"></i>
                      <img
                        className=" pt-0 mt-0 automation-action-vendor-badge"
                        alt="{}"
                        src="https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/dialpadicon.png"
                      ></img>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-salmon p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>1 Month Later
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-mailbox"></i>Send - Mail
                      </span>

                      <i className="fal fa-long-arrow-right ml-2 mr-2 calMess"></i>
                      <img
                        className=" pt-0 mt-0 automation-action-vendor-badge"
                        alt="{}"
                        src="https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/directmailmanagericon.png"
                      ></img>
                    </h6>

                    <h5 className="text-center mb-3 mt-3 text-info">
                      <i className="fas fa-arrow-down" />
                    </h5>

                    <h6 className="mb-0">
                      <span className="badge badge-pill badge-success bg-salmon p-2 px-3'">
                        <i className="far fa-clock mr-2"></i>6 Month Later
                      </span>

                      <span className="calMess badge badge-pill border border-info p-2 px-3 ml-2">
                        <i className="mr-2 far fa-at"></i>Send - Email
                      </span>

                      <i className="fal fa-long-arrow-right ml-2 mr-2 calMess"></i>
                      <img
                        className=" pt-0 mt-0 automation-action-vendor-badge"
                        alt="{}"
                        src="https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/microsofticon.png"
                      ></img>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {hasAccess === true && (
          <>
            <div className="col-12 mb-3">
              {sections.map((tab) => {
                let buttonClassList = ['btn', 'btn-sm', 'mr-2'];

                if (currentTab === tab.id) {
                  buttonClassList.push(tab.successClass);
                } else {
                  buttonClassList.push('border-secondary');
                }

                let iconClassList = ['far', tab.icon];

                return (
                  <span
                    onClick={(e) => {
                      setCurrentTab(tab.id);
                    }}
                    key={tab.id}
                    className={buttonClassList.join(' ')}
                  >
                    <i className={iconClassList.join(' ')}></i> {tab.label}
                  </span>
                );
              })}
            </div>
            <div className="col-12">
              {currentTab === 'manage' && (
                <section className="ds">
                  <AgentAutomationManagePanel {...props} />
                </section>
              )}
              {currentTab === 'schedule' && (
                <section className="ds">
                  <AgentAutomationSchedulePanel {...props} />
                </section>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}
